import styled, { css } from 'styled-components'
import { background, BackgroundProps, PaddingProps } from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { Flex } from 'Components/UI'
import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

type ReverseProps = {
  reverse?: boolean
}

type ContainerProps = BackgroundProps & PaddingProps & ReverseProps

const reverseCss = ({ reverse }: ReverseProps) =>
  reverse &&
  css`
    flex-direction: row-reverse;
  `

const shouldForwardProp = (prop: number | string) => {
  return ![...DIV_SHOULD_FORWARD_PROP, 'reverse'].includes(String(prop))
}

// Rendered as a next/link anchor (real crawlable prev/next links between
// case pages) — reset the UA link styling.
export const Container = styled(Flex).withConfig({
  shouldForwardProp,
})<ContainerProps>`
  width: 100%;
  align-items: center;
  justify-content: space-between;
  height: 150px;
  border-radius: 24px;
  cursor: pointer;
  text-decoration: none;
  transition: ${themeGet('transition')};

  :hover {
    transform: scaleX(1.005);
  }

  ${reverseCss};

  ${background};
`

export const Label = styled(Flex).withConfig({
  shouldForwardProp,
})<ReverseProps>`
  align-items: center;

  ${reverseCss};
`

export const ImageHolder = styled(Flex)`
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  overflow: hidden;
  position: relative;
  height: 48px;
  width: 48px;
  border-radius: 25px;
  background-color: ${themeGet('colors.white')};
  border: 2px solid ${themeGet('colors.white')};

  img {
    width: 80%;
    object-fit: contain;
  }

  @media screen and (min-width: ${themeGet('breakpoints.0')}) {
    height: 48px;
    width: 48px;
  }
`

const arrowHolderReverseCss = ({ reverse }: ReverseProps) =>
  reverse &&
  css`
    transform: rotateZ(180deg);
  `

export const ArrowHolder = styled.div.withConfig({
  shouldForwardProp,
})<ReverseProps>`
  color: ${themeGet('colors.white')};

  svg {
    width: 28px;
    height: 28px;
  }

  ${arrowHolderReverseCss}
`
